module.exports = __webpack_public_path__ + "fonts/11.svg";